var $=jQuery;
jQuery(document).ready(function ($) {
  // if (window.location.pathname === '/collections/all') {
  //   window.location.replace('/collections/alle-produkte');
  // }
  $('.dropdown-blog-btn').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('footer .has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  
  setTimeout(function() {
    document.querySelectorAll('.jm-star-rating_main').forEach(function(el) {
      el.classList.add('show');
    });
  }, 500);
  function slider_mobile() {
    if($(window).width() <= 949){ 
      
        var swiper = new Swiper('.custom-anouncement-bar', {
          slidesPerView: 1,
          spaceBetween:0,
          loop: true,
          centeredSlides: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          }
        });
        
      const $el = $(".no-slide.collection-featured .collection-featured-slider > ul");

      if ($el.find("li").length > 2) {
          $el.flickity({
              prevNextButtons: false,
              groupCells: false,
              cellAlign: 'left',
              contain: true
          });
      }
      
      const $nt_exp = $(".nt_exp .expert-bottom-inner .metaobject-list-expert").flickity({
          prevNextButtons: true,
          groupCells: false,
          cellAlign: 'left',
          // adaptiveHeight: true,
          contain: true,
          pageDots: false
      });
      const $nt_warum = $(".nt_warum .multicolumn-list").flickity({
            prevNextButtons: false,
            groupCells: false,
            cellAlign: 'center',
            adaptiveHeight: true,
            contain: true
        });
      const $nt_blog__posts = $("ul.blog__posts.articles-wrapper").flickity({
            prevNextButtons: false,
            groupCells: false,
            cellAlign: 'left',
            adaptiveHeight: true,
            contain: true,
            pageDots:true
        });
      const $nt_ein = $(".nt_ein .multicolumn-list").flickity({
            prevNextButtons: false,
            groupCells: false,
            cellAlign: 'center',
            adaptiveHeight: true,
            contain: true
        });
      const $nt_getreidefrei = $(".nt_getreidefrei .page-width .static-items").flickity({
            prevNextButtons: false,
            groupCells: false,
            cellAlign: 'left',
            adaptiveHeight: true,
            contain: true,
            pageDots:true
        });
      const $wirkstoff = $(".tabs-wirkstoff.tabcontent .wirkstoff-metaobject.ul_style").flickity({
            prevNextButtons: false,
            groupCells: false,
            cellAlign: 'center',
            adaptiveHeight: false,
            pageDots:true,
            autoPlay: 3000,
            wrapAround: true,
            contain: true
        });
      
      
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
   //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".nt_leicht .static-items.col-3");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        prevNextButtons: true,
                        groupCells: false,
                        cellAlign: 'center',
                        adaptiveHeight: false,
                        pageDots:false,
                        autoPlay: 3000,
                        wrapAround: true
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
  $(document).on('click', '.load-more-btn', function () {
    var $wrapper = $(this).closest('.tabs-zusammensetzung'); // IMPORTANT
    var $items = $wrapper.find('.zusammen-metaobject .item.hidden-item:lt(6)');

    $items.removeClass('hidden-item');

    // show extra content
    $wrapper.find('.load-less-btn').removeClass('hidden-item');
    $wrapper.find('.zusammen-content-content_bottom').removeClass('hidden-item');
    $wrapper.find('.zusammen-middle_text').removeClass('hidden-item');
    $wrapper.find('.zusammen-content-2').removeClass('hidden-item');
    $wrapper.find('.zusammensetzung_2').removeClass('hidden-item');

    if ($wrapper.find('.item.hidden-item').length === 0) {
        $(this).addClass('hidden-item');
    }
  });

  $(document).on('click', '.load-less-btn', function () {
    var $wrapper = $(this).closest('.tabs-zusammensetzung'); // IMPORTANT
    var $items = $wrapper.find('.zusammen-metaobject .item.hidden-item:lt(6)');

    // hide all after first 6
    $items.slice(6).addClass('hidden-item');

    // hide extra content
    $wrapper.find('.zusammen-content-content_bottom').addClass('hidden-item');
    $wrapper.find('.zusammen-middle_text').addClass('hidden-item');
    $wrapper.find('.zusammen-content-2').addClass('hidden-item');
    $wrapper.find('.zusammensetzung_2').addClass('hidden-item');

    // toggle buttons
    $wrapper.find('.load-more-btn').removeClass('hidden-item');
    $(this).addClass('hidden-item');
  });


  // slider pdp
  $("ul.product-single__thumbnails").flickity({
        pageDots: false,
      // freeScroll: false,
      // wrapAround: true,
      prevNextButtons: false,
      autoPlay: false,
      groupCells: true,
      cellAlign: 'left',
      asNavFor: '.product-single__gallery'
  });
  $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: true,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
      $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  });
  $('.product-single__thumbnails li').first().addClass('active');
  
  // Thumbnail click event to change the gallery image
  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  });
  // slider pdp

  $('.acc-head').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.acc-content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.acc-content').slideUp();
      $('.acc-head').removeClass('active');
      $(this).siblings('.acc-content').slideToggle();
      $(this).toggleClass('active');
    }
  });
  // add to cart 
  $(document).on('submit', '.js-card-add-to-cart', function(e) {
      e.preventDefault();

      var $form = $(this);
      var formData = new FormData(this);
      var id = formData.get('id');

      if (!id) return;

      var $btn = $form.find('[type="submit"]');
      $btn.prop('disabled', true).addClass('loading');

      $.ajax({
          url: '/cart/add.js',
          method: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          dataType: 'json',

          success: function(item) {

              fetch('/?sections=cart-drawer,cart-icon-bubble')
              .then(response => response.json())
              .then(data => {

                  $('cart-drawer').replaceWith(data['cart-drawer']);
                  $('#cart-icon-bubble').html(data['cart-icon-bubble']);

                  const cartDrawer = document.querySelector('cart-drawer');
                  if (cartDrawer) {
                      cartDrawer.open();
                  }

              });

          },

          complete: function() {
              $btn.prop('disabled', false).removeClass('loading');
          }
      });
  });
  // add to cart 
});



// document.addEventListener("DOMContentLoaded", function () {
//   const popup = document.getElementById("custom-popup");
//   const closeBtn = document.getElementById("close-popup");

//   if (!popup) return;

//   const url = new URL(window.location.href);
//   const isNewsletterSuccess =
//     url.searchParams.get("customer_posted") === "true" &&
//     window.location.hash === "#NewsletterForm";

//   function openPopup() {
//     popup.style.display = "flex";
//   }

//   function closePopup() {
//     popup.style.display = "none";
//   }

//   if (closeBtn) {
//     closeBtn.addEventListener("click", function () {
//       closePopup();
//     });
//   }
  
//   //  show ss 
//   if (isNewsletterSuccess) {
//     if (sessionStorage.getItem("popupWasOpenedThisVisit") === "true") {
//       openPopup();
//     }
//     return;
//   }

//   //  show one
//   if (!localStorage.getItem("customPopupShown")) {
//     setTimeout(function () {
//       openPopup();
//       localStorage.setItem("customPopupShown", "true");
//       sessionStorage.setItem("popupWasOpenedThisVisit", "true");
//     }, 1000);
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("custom-popup");
  const closeBtn = document.getElementById("close-popup");
  const popupStorageKey = "custom_popup_has_opened";
  if (!popup) return;

  // Only show on homepage
  if (window.location.pathname !== "/") return;

  function openPopup() {
    popup.style.display = "flex";

    // Mark popup as already opened in this browser session
    sessionStorage.setItem(popupStorageKey, "true");
  }

  function closePopup() {
    popup.style.display = "none";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closePopup);
  }

  if (sessionStorage.getItem(popupStorageKey) === "true") return;
  // Open once after 5 seconds
  setTimeout(function () {
    openPopup();
  }, 30000);
});

document.addEventListener("DOMContentLoaded", function () {
  const content = document.querySelector('.article-template__content');
  const tocList = document.getElementById('toc-list');

  if (!content || !tocList) return;

  const headings = content.querySelectorAll('h2');
  
  headings.forEach((heading, index) => {
    // Create ID if not exists
    if (!heading.id) {
      heading.id = heading.innerText.toLowerCase().replace(/\s+/g, '-');
    }

    const li = document.createElement('li');
    li.classList.add('toc-' + heading.tagName.toLowerCase());

    const a = document.createElement('a');
    a.href = '#' + heading.id;
    a.innerText = heading.innerText;

    li.appendChild(a);
    tocList.appendChild(li);
  });
   // Add FAQ if exists
  const faq = document.getElementById('faq');
  if (faq) {
    const li = document.createElement('li');
    li.classList.add('toc-faq');

    const a = document.createElement('a');
    a.href = '#faq';
    a.innerText = 'FAQ';

    li.appendChild(a);
    tocList.appendChild(li);
  }

  // Add Quellen if exists
  const quellen = document.getElementById('quellen');
  if (quellen) {
    const li = document.createElement('li');
    li.classList.add('toc-quellen');

    const a = document.createElement('a');
    a.href = '#quellen';
    a.innerText = 'Quellen';

    li.appendChild(a);
    tocList.appendChild(li);
  }
});

function addIdsToH3() {
  const container = document.querySelector('.article-template__content-main');
  if (!container) {
    // console.log('No container found');
    return;
  }

  const headings = container.querySelectorAll('h2');

  // console.log('H3 found:', headings.length);

  headings.forEach((heading) => {
    if (!heading.id) {
      let slug = heading.innerText
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-');

      // ensure unique
      let uniqueSlug = slug;
      let i = 1;
      while (document.getElementById(uniqueSlug)) {
        uniqueSlug = slug + '-' + i;
        i++;
      }

      heading.id = uniqueSlug;
    }
  });
}

// Run multiple times (Shopify safe)
document.addEventListener("DOMContentLoaded", addIdsToH3);
document.addEventListener("shopify:section:load", addIdsToH3);

// fallback (VERY important for Dawn)
setTimeout(addIdsToH3, 500);
setTimeout(addIdsToH3, 1500);

document.addEventListener('click', function (e) {
  const link = e.target.closest('.toc a');
  if (!link) return;

  e.preventDefault();

  const targetId = link.getAttribute('href').substring(1);
  const target = document.getElementById(targetId);

  if (!target) {
    console.log('Target not found:', targetId);
    return;
  }

  const offset = 100; // adjust for sticky header
  const position = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: position,
    behavior: 'smooth'
  });
});
 

document.querySelectorAll('.product__info-wrapper .appio-rating-badge.appio-rating-major, .rating_block').forEach(button => {
  button.addEventListener('click', function(e) {
    e.preventDefault();

    const target = document.querySelector('#judgeme_product_reviews');

    if (target) {
      const offset = 120; // header height
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('.shopify-section-header-sticky');
  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  });
});
// document.addEventListener('DOMContentLoaded', function () {
//     function updateLabels() {
//         document.querySelectorAll('.kaching-subscriptions__selling-plan-label').forEach(label => {
//             const text = label.textContent.trim();

//             const match = text.match(/^(\d+%)\s+(.*)$/);

//             if (match) {
//                 label.textContent = `${match[2]} ${match[1]}`;
//             }
//         });
//     }

//     updateLabels();

//     new MutationObserver(updateLabels).observe(document.body, {
//         childList: true,
//         subtree: true
//     });
// });


// function changeAccountButtonText() {
//   const lang = document.documentElement.lang.toLowerCase();

//   // Don't change text on English pages
//   if (lang.startsWith('en')) return;

//   document.querySelectorAll('a').forEach(link => {
//     if (link.textContent.trim() === 'Sammlungen entdecken') {
//       link.textContent = 'PRODUKTE ENTDECKEN';
//     }
//   });
// }

// document.addEventListener('DOMContentLoaded', () => {
//   changeAccountButtonText();

//   const observer = new MutationObserver(changeAccountButtonText);
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });


  function openTabFromHash() {
    if (!window.location.hash.includes('#button-')) return;

    const button = document.querySelector(window.location.hash);
    if (!button) return;

    button.click();

    function scrollToButton() {
      const header = document.querySelector(
        'sticky-header, .header-wrapper, .shopify-section-header-sticky'
      );

      const headerHeight = header ? header.offsetHeight : 0;

      const top =
        button.getBoundingClientRect().top +
        window.scrollY -
        headerHeight -
        20;

      window.scrollTo({
        top: top,
        behavior: 'auto'
      });
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(scrollToButton);
    });

    setTimeout(scrollToButton, 300);
    setTimeout(scrollToButton, 800);
  }

  window.addEventListener('load', openTabFromHash);
  window.addEventListener('pageshow', openTabFromHash);
  window.addEventListener('hashchange', openTabFromHash);
  